import React from 'react';
import axios from "../../../../containers/api";
import {Button, CardTitle} from "reactstrap";
import {showCatchError} from "../../../../helpers/Utils";
import {Table} from "../../../../components/table/Table";
import {Separator} from "../../../../components/common/CustomBootstrap";

class MainBranchAgencies extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            AgentMainToEdit: this.props.AgentMainToEdit,
            AllAgencies: this.props.AllAgencies,
            Agencies: []
        }
    }

    componentDidMount() {
        this.GetMainBranchById();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.AllAgencies !== this.props.AllAgencies) {
            this.setState({
                AllAgencies: this.props.AllAgencies
            });
        }
    }

    GetMainBranchById = () => {
        this.props.showSpinner();
        axios.get('api/AgencyApi/GetAgencyMainBranches?agencyId=' + this.state.AgentMainToEdit.agentMainId)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({Agencies: res.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    removeFromBranches = (agentId) => {
        this.props.showSpinner();
        axios.get('api/AgencyApi/RemoveAgentMainIdFromAgent?agentId=' + agentId)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert("نمایندگی با موفقیت حذف شد", "success");
                this.GetMainBranchById();
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    addToBranches = (agentId) => {
        this.props.showSpinner();
        axios.get('api/AgencyApi/SetAgentMainIdForAgent?agentId=' + agentId + '&agentMainId=' + this.state.AgentMainToEdit.agentMainId)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert("نمایندگی به دفتر مرکزی افزوده شد", "success");
                this.GetMainBranchById();
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    render() {
        return (
            <div>
                <CardTitle>
                    لیست نمایندگی‌های
                    {" "}
                    {this.state.AgentMainToEdit && this.state.AgentMainToEdit.agentMainName}
                </CardTitle>
                <Table
                    tableHeaders={[
                        "شناسه",
                        "نام کامل",
                        "کد ملی",
                        "موبایل",
                        "حذف",
                    ]}

                    tableRow={this.state.Agencies === null ? [] : this.state.Agencies}

                    tableData={[
                        agency => {
                            return "Agent" + agency.agentID;
                        },
                        agency => {
                            return agency.agentFullName;
                        },
                        agency => {
                            return agency.meliCode;
                        },
                        agency => {
                            return agency.mobile;
                        },
                        agency => {
                            return (
                                <Button outline color="danger" size="sm"
                                        onClick={() => this.removeFromBranches(agency.agentID)}>
                                    حذف
                                </Button>
                            )
                        }
                    ]}
                />

                <Separator className="my-5" />

                <CardTitle>لیست کل نمایندگی‌ها</CardTitle>
                <Table
                    tableHeaders={[
                        "شناسه",
                        "نام کامل",
                        "کد ملی",
                        "موبایل",
                        "افزودن",
                    ]}

                    tableRow={this.state.AllAgencies === null ? [] : this.state.AllAgencies}

                    tableData={[
                        agency => {
                            return "Agent" + agency.agentID;
                        },
                        agency => {
                            return agency.agentFullName;
                        },
                        agency => {
                            return agency.meliCode;
                        },
                        agency => {
                            return agency.mobile;
                        },
                        agency => {
                            return (
                                <Button outline color="success" size="sm"
                                        onClick={() => this.addToBranches(agency.agentID)}>
                                    افزوردن
                                </Button>
                            )
                        }
                    ]}
                />
            </div>
        );
    }
}

export default MainBranchAgencies;